export default "__VITE_ASSET__B2D4P82s__"